import React from 'react';
export const NavIconRunway = ({ color, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M2 20h20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20V5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M8 9l4-4 4 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="6.5" cy="16" r="1" fill={color} opacity="0.5" />
    <circle cx="17.5" cy="16" r="1" fill={color} opacity="0.5" />
    <circle cx="6.5" cy="12" r="1" fill={color} opacity="0.3" />
    <circle cx="17.5" cy="12" r="1" fill={color} opacity="0.3" />
  </svg>
);
export const NavIconGauge = ({ color, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 14a8 8 0 1 1 16 0" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 14l-2.5-5" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="12" cy="14" r="2" fill={color} />
    <path d="M8 19h8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export const NavIconRoute = ({ color, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="5" cy="18" r="2.5" stroke={color} strokeWidth="1.5" fill={color} fillOpacity="0.15" />
    <circle cx="19" cy="6" r="2.5" stroke={color} strokeWidth="1.5" fill={color} fillOpacity="0.15" />
    <path d="M7.5 16L16.5 8" stroke={color} strokeWidth="1.5" strokeDasharray="3 2.5" strokeLinecap="round" />
  </svg>
);
export const NavIconTarget = ({ color, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="5" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="1.5" fill={color} />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
